import React, { forwardRef, useImperativeHandle, useMemo, useState } from "react";
import SN_SYS_BAS_REP_001_PREVIEW from "./SN_SYS_BAS_REP_001_PREVIEW";

interface popupProps {
  modalRef?: any;
  rows?: any[];
}

// 그리드와 같은 형태로 크기를 보여 준다. (바이트 -> KB 올림)
const toKiloBytes = (value: any) => {
  if (value === null || value === undefined || value === "") return "";
  const bytes = Number(value);
  if (Number.isNaN(bytes)) return String(value);
  if (bytes <= 0) return "0 KB";
  return `${Math.max(1, Math.ceil(bytes / 1024)).toLocaleString("ko-KR")} KB`;
};

/**
 * 미리보기 팝업.
 * 체크한 파일 목록을 왼쪽에 두고, 고른 파일의 내용을 오른쪽에 보여 준다.
 * 파일이 1건이면 목록 없이 내용만 보여 준다.
 */
const SN_SYS_BAS_REP_001_POP_002 = forwardRef(
  ({ rows }: popupProps, ref: React.Ref<any>) => {
    const [selectedIdx, setSelectedIdx] = useState<number>(0);

    // 확인 버튼을 쓰지 않는 조회용 팝업이라 넘길 값이 없다.
    useImperativeHandle(ref, () => ({
      getSelectedValue: async () => undefined,
    }));

    const list = useMemo(() => rows || [], [rows]);
    const current = list[selectedIdx] || null;

    return (
      <div
        className="flex flex-row gap-2"
        style={{ flex: 1, minHeight: 0, height: "100%" }}
      >
        {list.length > 1 && (
          <div
            className="flex flex-col"
            style={{
              width: "220px",
              flexShrink: 0,
              border: "1px solid #babfc7",
              borderRadius: "4px",
              overflow: "auto",
              backgroundColor: "#fff",
            }}
          >
            {list.map((row: any, idx: number) => (
              <button
                key={row?.id ?? idx}
                type="button"
                className="text-left text-xs"
                style={{
                  padding: "6px 8px",
                  borderBottom: "1px solid #f0f0f0",
                  backgroundColor: idx === selectedIdx ? "#e8f1fb" : "#fff",
                  wordBreak: "break-all",
                }}
                onClick={() => setSelectedIdx(idx)}
              >
                <div>{String(row?.nm_file || "")}</div>
                <div style={{ color: "#888" }}>{toKiloBytes(row?.qt_size)}</div>
              </button>
            ))}
          </div>
        )}

        <div
          className="flex flex-col gap-1"
          style={{ flex: 1, minWidth: 0, minHeight: 0 }}
        >
          <div
            className="text-xs text-gray-600"
            style={{ wordBreak: "break-all" }}
          >
            {String(current?.nm_file || "")}
            {list.length > 1 ? ` (${selectedIdx + 1}/${list.length})` : ""}
          </div>
          <SN_SYS_BAS_REP_001_PREVIEW row={current} variant="fill" />
        </div>
      </div>
    );
  }
);

export default SN_SYS_BAS_REP_001_POP_002;
